import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// DS
import {
  Col,
  Form,
  VertInput,
  Row,
  VertTypography,
  VertSelect,
  VertCheckbox,
} from '@vertem-core/vertice-ds';
import { LoadingOutlined } from '@ant-design/icons';

// STYLES
import 'Assets/styles/default/components/Forms/FormsStyles.less';
import 'Assets/styles/default/components/Profile/Profile.less';
import SpotltmClient from 'Services/Apis/Spot/ltmApiService';
import { debounce } from 'lodash';
import { useSelector } from 'react-redux';
import MaskedInput from 'pages/newSolicitation/components/InputMask';
import { handleAddressNumberOutput } from 'Utils/commons/address';
import yn from 'yn';

// MOCK
export const listUF = [
  { value: 'AC', label: 'AC', availability: true },
  { value: 'AL', label: 'AL', availability: true },
  { value: 'AP', label: 'AP', availability: true },
  { value: 'AM', label: 'AM', availability: true },
  { value: 'BA', label: 'BA', availability: true },
  { value: 'CE', label: 'CE', availability: true },
  { value: 'DF', label: 'DF', availability: true },
  { value: 'ES', label: 'ES', availability: true },
  { value: 'GO', label: 'GO', availability: true },
  { value: 'MA', label: 'MA', availability: true },
  { value: 'MT', label: 'MT', availability: true },
  { value: 'MS', label: 'MS', availability: true },
  { value: 'MG', label: 'MG', availability: true },
  { value: 'PA', label: 'PA', availability: true },
  { value: 'PB', label: 'PB', availability: true },
  { value: 'PR', label: 'PR', availability: true },
  { value: 'PE', label: 'PE', availability: true },
  { value: 'PI', label: 'PI', availability: true },
  { value: 'RJ', label: 'RJ', availability: true },
  { value: 'RN', label: 'RN', availability: true },
  { value: 'RS', label: 'RS', availability: true },
  { value: 'RO', label: 'RO', availability: true },
  { value: 'RR', label: 'RR', availability: true },
  { value: 'SC', label: 'SC', availability: true },
  { value: 'SP', label: 'SP', availability: true },
  { value: 'SE', label: 'SE', availability: true },
  { value: 'TO', label: 'TO', availability: true },
];

// FORMS DELIVERY ADRRESS PERSONAL
const FormsDeliveryAddressPersonal = ({ ...props }) => {
  const { onChange, form, isValid, setFormAddress, validateIE } = props;
  const [useForm] = Form.useForm();
  const [loadingCep, setLoadingCep] = useState(false);
  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);
  const {
    user: { profile, access_token },
  } = userInfos;
  const username = profile.username || profile['custom:login'];

  const config = {
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    Authorization: `Bearer ${access_token}`,
    username: username,
  };

  useEffect(() => {
    if (form) {
      let addressNumber = handleAddressNumberOutput(form.number.value);

      if (addressNumber == "S/N")
        setIsCheckboxChecked(true);

      useForm.setFieldsValue({
        zipCode: form.zipCode.value,
        state: form.state.value,
        street: form.street.value,
        number: addressNumber,
        complement: form.complement.value,
        district: form.district.value,
        city: form.city.value,
      });

      useForm.validateFields();
    }
  }, []);

  const handleChange = (name, value) => {
    const fieldsErros = useForm.getFieldsError();
    const hasValid = fieldsErros.find((a) => a.errors.length > 0)
      ? false
      : true;
    isValid({ deliveryAddress: hasValid });
    onChange(name, value);
  };

  const validateCEP = (rule, value) => {
    if (!value) {
      useForm.setFields([
        {
          name: 'zipCode',
          errors: ['CEP precisa ser preenchido.'],
        },
      ]);
    } else if (!/^\d{5}-?\d{3}$/.test(value)) {
      useForm.setFields([
        {
          name: 'zipCode',
          errors: ['CEP inválido. O CEP deve estar no formato "#####-###".'],
        },
      ]);
    }
  };
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(
    useForm.getFieldValue('number') === 'S/N'
  );

  useEffect(() => {
    setIsCheckboxChecked(useForm.getFieldValue('number') === 'S/N');
  }, [useForm.getFieldValue('number')]);

  useEffect(() => {
    const fieldsErros = useForm.getFieldsError();
    const hasValid = fieldsErros.find((a) => a.errors.length > 0)
      ? false
      : true;
    isValid({ deliveryAddress: hasValid });
  }, [useForm.getFieldError()]);

  const fetchCep = async (valueCep) => {
    const cepRegex = /^[0-9]{8}$/;
    if (!cepRegex.test(valueCep)) {
      return;
    }
    setLoadingCep(true);

    try {
      const response = await SpotltmClient.get(
        `/cloudloyalty/v1/addresses/${valueCep}`,
        {
          headers: config,
        }
      );

      setLoadingCep(false);
      useForm.setFieldsValue({
        street: response?.data?.street ? `${response.data.streetType} ${response.data.street}` : '',
        district: response.data?.district,
        city: response.data.city,
        state: response.data.state,
        reference: response.data.streetType,
      });
      useForm.resetFields(['number', 'complement']);

      setFormAddress({
        zipCode: {
          value: useForm.getFieldValue('zipCode'),
          disabled: false,
        },
        state: {
          value: useForm.getFieldValue('state'),
          disabled: false,
        },
        street: {
          value: useForm.getFieldValue('street'),
          disabled: false,
        },
        number: {
          value: useForm.getFieldValue('number'),
          disabled: false,
        },
        complement: {
          value: useForm.getFieldValue('complement'),
          disabled: false,
        },
        district: {
          value: useForm.getFieldValue('district'),
          disabled: false,
        },
        city: {
          value: useForm.getFieldValue('city'),
          disabled: false,
        },
      });

      useForm.validateFields([
        'street',
        'district',
        'city',
        'state',
        'number',
        'complement',
      ]);
      validateIE(useForm.getFieldValue('state'));
    } catch (error) {
      if (error.response && error.response.status === 422) {
        useForm.setFields([
          {
            name: 'zipCode',
            errors: ['CEP não encontrado'],
          },
        ]);
      } else {
        useForm.setFields([
          {
            name: 'zipCode',
            errors: ['Ocorreu um erro ao buscar o CEP'],
          },
        ]);
        console.info('Ocorreu um erro ao buscar o CEP:', error);
      }
    } finally {
      setLoadingCep(false);
    }
  };
  const fetchCepDebounced = debounce(fetchCep, 500);

  return (
    <Col className="forms-method-payment-wrapper col-12 container-form-address-personal">
      <div>
        <Row className="checkout-summary-title">
          <VertTypography.Title level={3} className="margin-bottom-small">
            Endereço de entrega
          </VertTypography.Title>
        </Row>
        <Form
          name="FormsDeliveryAddressPersonal"
          form={useForm}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          autoComplete="off"
          layout="vertical"
          className="form-delivery-address-personal"
          validateTrigger={['onBlur']}
          onBlur={() => {
            setFormAddress({
              zipCode: {
                value: useForm.getFieldValue('zipCode'),
                disabled: false,
              },
              state: {
                value: useForm.getFieldValue('state'),
                disabled: false,
              },
              street: {
                value: useForm.getFieldValue('street'),
                disabled: false,
              },
              number: {
                value: useForm.getFieldValue('number'),
                disabled: false,
              },
              complement: {
                value: useForm.getFieldValue('complement'),
                disabled: false,
              },
              district: {
                value: useForm.getFieldValue('district'),
                disabled: false,
              },
              city: {
                value: useForm.getFieldValue('city'),
                disabled: false,
              },
            });
          }}
        >
          {/** CEP _ ESTADO **/}
          <div className="formItem">
            <Form.Item name="zipCode" rules={[{ validator: validateCEP }]}>
              <MaskedInput
                mask={'99999-999'}
                label="CEP"
                placeholder=""
                prefix={<LoadingOutlined />}
                template="marketplace"
                disabled={form.zipCode.disabled}
                onChange={(e) => {
                  const value = e.replace(/[^0-9]/g, '');
                  if (value.length === 8) {
                    fetchCepDebounced(value);
                  }
                }}
              />
            </Form.Item>

            <div className="container-state-delivery-address">
              <Form.Item
                name="state"
                validateTrigger={['onBlur']}
                rules={[
                  { required: true, message: 'Estado precisa ser preenchido.' },
                ]}
              >
                <VertSelect
                  items={listUF}
                  showSearch
                  label="UF"
                  placeholder=""
                  template="marketplace"
                  disabled={form.state.disabled}
                  loading={loadingCep}
                  onChange={(uf) => {
                    handleChange('state', uf);
                    validateIE(uf);
                  }}
                />
              </Form.Item>
            </div>
          </div>
          {/* ENDEREÇO */}
          <div className="formItem">
            <Form.Item
              name="street"
              validateTrigger={['onBlur']}
              rules={[
                { required: true, message: 'Endereço precisa ser preenchido.' },
              ]}
            >
              <VertInput
                label="Endereço"
                disabled={form.street.disabled || loadingCep}
                onChange={({ target }) => handleChange('street', target.value)}
              />
            </Form.Item>
          </div>
          {/* NUMERO _ COMPLEMENTO _ BAIRRO */}
          <div className="formItem">
            <div>
              <Form.Item
                name="number"
                validateTrigger={['onChange']}
                rules={[
                  { required: true, message: 'Número precisa ser preenchido.' },
                  { max: 20, message: 'Número deve ter no máximo 20 caracteres.' },
                  {
                    pattern: /^(S\/N|\d+)$/,
                    message: 'Somente números ou S/N.',
                  },
                ]}
              >
                <VertInput
                  label="Número"
                  disabled={form.number.disabled || loadingCep}
                  onChange={({ target }) => {
                    if (!/^(S\/N|\d+)$/.test(target.value)) {
                      useForm.setFields([
                        {
                          name: 'number',
                          errors: ['Somente números ou S/N.'],
                        },
                      ]);
                    }

                    handleChange('number', target.value);
                  }}
                />
              </Form.Item>
              <VertCheckbox
                onClick={() => {
                  const currentValue = useForm.getFieldValue('number');
                  if (currentValue === 'S/N') {
                    useForm.setFieldsValue({ number: '' });
                    useForm.validateFields(['number']);
                    const fieldsErros = useForm.getFieldsError();
                    const hasValid = fieldsErros.find(
                      (a) => a.errors.length > 0
                    )
                      ? false
                      : true;
                    isValid({ deliveryAddress: hasValid });
                    setIsCheckboxChecked(false);
                  } else {
                    useForm.setFieldsValue({ number: 'S/N' });
                    setIsCheckboxChecked(true);
                  }
                }}
                checked={isCheckboxChecked}
                className="vert-checkbox-address"
                disabled={!yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)}
              >
                Sem número
              </VertCheckbox>
            </div>

            <Form.Item
              name="complement"
              validateTrigger={['onChange']}
              rules={[
                {
                  required: false,
                  message: 'Complemento precisa ser preenchido.',
                },
                { pattern: /^[a-zA-Z0-9\s]*$/, message: 'O Campo complemento não aceita caracteres especiais.' },
                { max: 20, message: 'Complemento deve ter no máximo 20 caracteres.' },
              ]}
            >
              <VertInput
                label="Complemento"
                disabled={form.complement.disabled || loadingCep}
                onChange={({ target }) => {
                  handleChange('complement', target.value);
                }}
              />
            </Form.Item>
            <Form.Item
              name="district"
              validateTrigger={['onChange']}
              rules={[
                { required: true, message: 'Bairro precisa ser preenchido.' },
                { max: 20, message: 'Bairro deve ter no máximo 20 caracteres.' },
              ]}
            >
              <VertInput
                label="Bairro"
                disabled={form.complement.disabled || loadingCep}
                onChange={({ target }) =>
                  handleChange('district', target.value)
                }
              />
            </Form.Item>
          </div>
          {/* CIDADE _ PONTO REFERENCIA */}
          <div className="formItem">
            <Form.Item
              name="city"
              validateTrigger={['onBlur']}
              rules={[
                { required: true, message: 'Cidade precisa ser preenchido.' },
              ]}
            >
              <VertInput
                label="Cidade"
                disabled={form.city.disabled || loadingCep}
                onChange={({ target }) => handleChange('city', target.value)}
              />
            </Form.Item>
          </div>
        </Form>
      </div>
    </Col>
  );
};

const type = PropTypes.shape({
  value: PropTypes.any,
  disabled: PropTypes.bool,
});

FormsDeliveryAddressPersonal.propTypes = {
  form: PropTypes.shape({
    zipCode: type,
    state: type,
    street: type,
    number: type,
    complement: type,
    district: type,
    city: type,
    reference: type,
  }),
  onChange: PropTypes.func,
  isValid: PropTypes.func,
};

export default FormsDeliveryAddressPersonal;
